module.exports = __webpack_public_path__ + "static/logo-e904da0b3403963b39ff046051103442.svg";